// extracted by css-extract-rspack-plugin
export default {"ConflictingFilesWrapper":"MergeConflicts-module__ConflictingFilesWrapper__YGpMG","ConflictingFilesContent":"MergeConflicts-module__ConflictingFilesContent__JT_7L"};